import React from "react"
import { useAppSelector } from "hooks/hooksStore"
import "./ToggleButtonMenu.scss"

interface ToggleButtonMenuProps {
  action: () => void
}

function ToggleButtonMenu({ action }: ToggleButtonMenuProps) {
  // Redux State
  const isOpenSidebar = useAppSelector(state => state.sidebar.open)

  return (
    <div aria-hidden="true" className={`toggle-btn${isOpenSidebar ? " open" : ""}`} onClick={() => action()}>
      <span />
      <span />
      <span />
    </div>
  )
}

export default ToggleButtonMenu
